import { atom } from 'recoil';

const email = atom<string>({
  key: 'email',
  default: '',
  dangerouslyAllowMutability: true,
});

export default email;
